/* global t */
// Help articles for Home, AI advisor, the Øvrig pages (Min side, Support, Aktivitetslogg),
// the employee portal and personal finance. Merged into helpArticles() in help-articles.jsx.
// Screenshots use the PlummeDEMO business. Personal account data is never captured.
window.PlummeHelpArticlePacks = (window.PlummeHelpArticlePacks || []).concat([() => ({
  home: { id: 'home', title: t('ha.home.title'), category: t('ha.cat.start'), read: t('ha.read2'), route: 'hjem',
    keywords: t('ha.home.keywords'),
    lead: t('ha.home.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.home.quick'), text: t('ha.home.quickText') },
    { t: 'step', n: 2, title: t('ha.home.chart'), text: t('ha.home.chartText') },
    { t: 'step', n: 3, title: t('ha.home.follow'), text: t('ha.home.followText') },
    { t: 'step', n: 4, title: t('ha.home.deadlines'), text: t('ha.home.deadlinesText') },
    { t: 'step', n: 5, title: t('ha.home.balance'), text: t('ha.home.balanceText') },
    { t: 'tip', kind: 'tip', title: t('ha.home.ask'), text: t('ha.home.askText') }]
  },
  aiAdvisor: { id: 'aiAdvisor', title: t('ha.aiAdvisor.title'), category: t('ha.cat.ai'), read: t('ha.read3'), route: 'aiinnsikt',
    keywords: t('ha.aiAdvisor.keywords'),
    lead: t('ha.aiAdvisor.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.aiAdvisor.overview'), text: t('ha.aiAdvisor.overviewText') },
    { t: 'step', n: 2, title: t('ha.aiAdvisor.tasks'), text: t('ha.aiAdvisor.tasksText') },
    { t: 'step', n: 3, title: t('ha.aiAdvisor.scenarios'), text: t('ha.aiAdvisor.scenariosText') },
    { t: 'figure', src: 'src/img/help/aiAdvisor-liquidity.png', caption: t('ha.aiAdvisor.scenarios') },
    { t: 'step', n: 4, title: t('ha.aiAdvisor.reports'), text: t('ha.aiAdvisor.reportsText') },
    { t: 'tip', kind: 'info', title: t('ha.aiAdvisor.basis'), text: t('ha.aiAdvisor.basisText') },
    { t: 'tip', kind: 'warn', title: t('ha.aiAdvisor.advice'), text: t('ha.aiAdvisor.adviceText') }]
  },
  activityLog: { id: 'activityLog', title: t('ha.activityLog.title'), category: t('ha.cat.setup'), read: t('ha.read2'), route: 'aktivitetslogg',
    keywords: t('ha.activityLog.keywords'),
    lead: t('ha.activityLog.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.activityLog.find'), text: t('ha.activityLog.findText') },
    { t: 'step', n: 2, title: t('ha.activityLog.details'), text: t('ha.activityLog.detailsText') },
    { t: 'tip', kind: 'info', title: t('ha.activityLog.access'), text: t('ha.activityLog.accessText') }]
  },
  myPage: { id: 'myPage', title: t('ha.myPage.title'), category: t('ha.cat.setup'), read: t('ha.read2'), route: 'minside',
    keywords: t('ha.myPage.keywords'),
    lead: t('ha.myPage.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.myPage.profile'), text: t('ha.myPage.profileText') },
    { t: 'step', n: 2, title: t('ha.myPage.password'), text: t('ha.myPage.passwordText') },
    { t: 'step', n: 3, title: t('ha.myPage.businesses'), text: t('ha.myPage.businessesText') },
    { t: 'step', n: 4, title: t('ha.myPage.more'), text: t('ha.myPage.moreText') },
    { t: 'tip', kind: 'info', title: t('ha.myPage.language'), text: t('ha.myPage.languageText') }]
  },
  support: { id: 'support', title: t('ha.support.title'), category: t('ha.cat.setup'), read: t('ha.read2'), route: 'support',
    keywords: t('ha.support.keywords'),
    lead: t('ha.support.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.support.open'), text: t('ha.support.openText') },
    { t: 'step', n: 2, title: t('ha.support.write'), text: t('ha.support.writeText') },
    { t: 'figure', src: 'src/img/help/support-new.png', caption: t('ha.support.write') },
    { t: 'tip', kind: 'tip', title: t('ha.support.screenshot'), text: t('ha.support.screenshotText') },
    { t: 'step', n: 3, title: t('ha.support.answer'), text: t('ha.support.answerText') },
    { t: 'step', n: 4, title: t('ha.support.close'), text: t('ha.support.closeText') }]
  },
  employeePortal: { id: 'employeePortal', title: t('ha.employeePortal.title'), category: t('ha.cat.payroll'), read: t('ha.read3'), route: 'lonn',
    keywords: t('ha.employeePortal.keywords'),
    lead: t('ha.employeePortal.lead'),
    blocks: [
    { t: 'heading', text: t('ha.employeePortal.employer') },
    { t: 'step', n: 1, title: t('ha.employeePortal.invite'), text: t('ha.employeePortal.inviteText') },
    { t: 'step', n: 2, title: t('ha.employeePortal.login'), text: t('ha.employeePortal.loginText') },
    { t: 'heading', text: t('ha.employeePortal.employee') },
    { t: 'para', text: t('ha.employeePortal.employeeText') },
    { t: 'step', n: 3, title: t('ha.employeePortal.expense'), text: t('ha.employeePortal.expenseText') },
    { t: 'step', n: 4, title: t('ha.employeePortal.travel'), text: t('ha.employeePortal.travelText') },
    { t: 'step', n: 5, title: t('ha.employeePortal.hours'), text: t('ha.employeePortal.hoursText') },
    { t: 'tip', kind: 'info', title: t('ha.employeePortal.revoke'), text: t('ha.employeePortal.revokeText') }]
  },
  personalFinance: { id: 'personalFinance', title: t('ha.personalFinance.title'), category: t('ha.cat.personal'), read: t('ha.read3'), route: 'privatokonomi',
    keywords: t('ha.personalFinance.keywords'),
    lead: t('ha.personalFinance.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.personalFinance.create'), text: t('ha.personalFinance.createText') },
    { t: 'step', n: 2, title: t('ha.personalFinance.import'), text: t('ha.personalFinance.importText') },
    { t: 'tip', kind: 'info', title: t('ha.bankReconcile.noConnection'), text: t('ha.personalFinance.noConnectionText') },
    { t: 'step', n: 3, title: t('ha.personalFinance.categories'), text: t('ha.personalFinance.categoriesText') },
    { t: 'step', n: 4, title: t('ha.personalFinance.tabs'), text: t('ha.personalFinance.tabsText') },
    { t: 'step', n: 5, title: t('ha.personalFinance.tax'), text: t('ha.personalFinance.taxText') },
    { t: 'tip', kind: 'tip', title: t('ha.personalFinance.family'), text: t('ha.personalFinance.familyText') }]
  }
})]);
